export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/team/dashboard/index.js